"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetLoadingState = exports.unsetData = exports.unsetActiveChild = exports.setLoadingState = exports.setData = exports.setActiveChild = exports.initialState = exports.getData = exports["default"] = void 0;
var _reduxActions = require("redux-actions");
var _flat = _interopRequireDefault(require("flat"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _remove2 = _interopRequireDefault(require("lodash/remove"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdTableRenders = _interopRequireDefault(require("cccisd-table-renders"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Fortress = window.cccisd && window.cccisd.fortress;

// import _map from 'lodash/map';

// import _forEach from 'lodash/forEach';

// import _first from 'lodash/first';

// Initial state
var initialState = exports.initialState = {
  loading: true,
  data: [],
  activeChild: {}
};

// Actions
var SET_LOADING_STATE = 'reportWrapper/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'reportWrapper/UNSET_LOADING_STATE';
var SET_DATA = 'reportWrapper/SET_DATA';
var UNSET_DATA = 'reportWrapper/UNSET_DATA';
var SET_ACTIVE_CHILD = 'reportWrapper/SET_ACTIVE_CHILD';
var UNSET_ACTIVE_CHILD = 'reportWrapper/UNSET_ACTIVE_CHILD';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setData = exports.setData = (0, _reduxActions.createAction)(SET_DATA);
var unsetData = exports.unsetData = (0, _reduxActions.createAction)(UNSET_DATA);
var setActiveChild = exports.setActiveChild = (0, _reduxActions.createAction)(SET_ACTIVE_CHILD);
var unsetActiveChild = exports.unsetActiveChild = (0, _reduxActions.createAction)(UNSET_ACTIVE_CHILD);
var _gatherSessionMetrics2 = function _gatherSessionMetrics(object, results) {
  if (Object.keys(object).includes('metricsList')) {
    object.metricsList.forEach(function (ml) {
      var matchingSessions = (0, _filter2["default"])(results, function (r) {
        return r.responseSet === ml.responseSet;
      });
      matchingSessions.forEach(function (ms) {
        // let matchingSession = _find(results, res => res.handle === ms.handle);
        var matchingIndex = (0, _findIndex2["default"])(results, function (res) {
          return res.handle === ms.handle;
        });
        results[matchingIndex] = Object.assign(results[matchingIndex], (0, _omit2["default"])(ml.devTags, ['__typename']));
      });
    });
  }
  (0, _remove2["default"])((0, _cloneDeep2["default"])(Object.keys(object), function (a) {
    return a === ' metricsList';
  })).forEach(function (key) {
    if ((0, _isArray2["default"])(object[key]) && (0, _isObject2["default"])(object[key][0])) {
      object[key].forEach(function (element) {
        _gatherSessionMetrics2(element, results);
      });
    } else if ((0, _isObject2["default"])(object[key])) {
      _gatherSessionMetrics2(object[key], results);
    }
  });
  return results;
};
var _gatherChildMetrics = function _gatherChildMetrics(children, results) {
  children.forEach(function (child) {
    results[child.pawn.pawnId] = !(0, _isNull2["default"])(child.metrics.devTags) ? child.metrics.devTags : {};
  });
  return results;
};
var _runQuery = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query, requiredVariables, entity) {
    var variables, formattedQuery, result;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          variables = {};
          if (!(0, _isEmpty2["default"])(requiredVariables)) {
            requiredVariables.forEach(function (v) {
              if ('from' in v && v.from === 'user') {
                variables[v.variable] = (0, _flat["default"])(Fortress)[v.field];
              } else {
                variables[v.variable] = (0, _get2["default"])(entity, v.field);
              }
            });
          }
          formattedQuery = (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context.n = 1;
          return _cccisdApollo.client.query({
            query: formattedQuery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 1:
          result = _context.v;
          return _context.a(2, result.data);
      }
    }, _callee);
  }));
  return function _runQuery(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _composeDisplaySettings = function _composeDisplaySettings(data, json) {
  var isChild = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var formattedData = [];
  if (isChild) {
    data.forEach(function (child) {
      var newChild = child;
      child.reportLabel = (0, _get2["default"])(child, json.acrossChildrenSettings.childTextFieldPath);
      formattedData.push(newChild);
    });
  } else {
    data.forEach(function (session) {
      var newSession = {};
      if ('sessionReportLabels' in json.displaySettings) {
        var displaySession = (0, _find2["default"])(json.displaySettings.sessionReportLabels, function (ds) {
          return ds.handle === session.handle;
        });
        if (displaySession) {
          var report = (0, _find2["default"])(displaySession.reports, function (settings) {
            if ('isSubNav' in json) {
              return settings.handle === json.reportHandle;
            }
            return settings.handle === json.handle;
          });
          newSession = Object.assign(session, (0, _omit2["default"])(report, 'handle'));
        }
      }
      formattedData.push(newSession);
    });
  }
  return formattedData;
};

// const _composeSessionObject = sessions => {
//     let sessionObj = {};
//     let sessionResponseSets = _map(sessions, 'responseSet');
//     _forEach(sessionResponseSets, rs => (sessionObj[rs] = {}));

//     return sessionObj;
// };

var _composeChildrenObject = function _composeChildrenObject(children) {
  var childrenObj = {};
  children.forEach(function (child) {
    childrenObj[child.pawn.pawnId] = {};
  });
  return childrenObj;
};
var _formatMetrics = function _formatMetrics(data, json) {
  var newData = [];
  data.forEach(function (d) {
    var newD = {};
    Object.keys(d).forEach(function (key) {
      var matchingKey = (0, _find2["default"])(json.metricsRenderers, function (mr) {
        return mr.key === key;
      });
      if (matchingKey) {
        var renderClass = _cccisdTableRenders["default"][matchingKey.renderAs["class"]][matchingKey.renderAs.type];
        newD[key] = renderClass(matchingKey.renderAs.settings);
      } else {
        newD[key] = d[key];
      }
    });
  });
  return newData;
};
var getData = exports.getData = function getData(_ref2) {
  var json = _ref2.json,
    entity = _ref2.entity,
    sessions = _ref2.sessions;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var response, formattedData, children, foo, filledChildren, filledSessionsByRS;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(setLoadingState());
            _context2.n = 1;
            return _runQuery(json.gql_query, json.requiredVariables, entity);
          case 1:
            response = _context2.v;
            formattedData = [];
            if (json.acrossChildren && (!('withPicker' in json.acrossChildrenSettings) || 'withPicker' in json.acrossChildrenSettings && json.acrossChildrenSettings.withPicker === false)) {
              // get children
              children = (0, _get2["default"])(response, json.acrossChildrenSettings.childrenPath);
              foo = _composeChildrenObject(children);
              filledChildren = _gatherChildMetrics(children, foo);
              Object.keys(filledChildren).forEach(function (pawnId) {
                formattedData.push(Object.assign(filledChildren[pawnId], (0, _find2["default"])(children, function (child) {
                  return child.pawn.pawnId === parseInt(pawnId, 10);
                })));
              });
              formattedData = _composeDisplaySettings(formattedData, json, true);
              if ('metricsRenderers' in json) {
                formattedData = _formatMetrics(formattedData, json);
              }
            } else {
              filledSessionsByRS = _gatherSessionMetrics2(response, sessions);
              formattedData = filledSessionsByRS;
              formattedData = _composeDisplaySettings(formattedData, json);

              // if (json.acrossChildren && json.acrossChildrenSettings.withPicker === true) {
              //     dispatch(setActiveChild(_first(_get(this.props.entity, json.childrenPath))));
              // }

              if ('metricsRenderers' in json) {
                formattedData = _formatMetrics(formattedData, json);
              }
            }
            dispatch(setData(formattedData));
            dispatch(unsetLoadingState());
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), SET_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action.payload
  });
}), UNSET_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: []
  });
}), SET_ACTIVE_CHILD, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeChild: action.payload
  });
}), UNSET_ACTIVE_CHILD, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeChild: {}
  });
}), initialState);